// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/ic-arrow-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="text"]:focus{
  outline: none;
}
.tabs {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #eceaea;
}
.tabs label {
  order: 1;
  color: #6d6e71;
  display: block;
  padding: 1rem 2rem;
  margin-right: 0.2rem;
  cursor: pointer;
  font-weight: bold;
  transition: background ease 0.2s;
}
.tabs .tab {
  order: 99;
  flex-grow: 1;
  width: 100%;
  display: none;
  padding: 1rem;
  background: #fff;
}
.tabs input[type="radio"] {
  display: none;
}
.tabs input[type="radio"]:checked + label {
  background: #fff;
  color: #e31837;
  border-bottom: 4px solid #e31837;
  padding-bottom: 10px;
}
.tabs input[type="radio"]:checked + label + .tab {
  display: block;
}

@media (max-width: 45em) {
  .tabs .tab,
  .tabs label {
    order: initial;
  }
  .tabs label {
    width: 100%;
    margin-right: 0;
    margin-top: 0.2rem;
  }
}

.tb_content {
  font-size: 12px;
  font-weight: 600;
  color: #000;
}

table {
  border-collapse: collapse;
  width: 100%;
}

tr {
  border-bottom: 1px solid #ddd;
}

.t_inner {
  text-align: center;
  margin-top: 8%;
  color: #d4cccc;
}

.rowBg1 {
  background-color: #fff;
  padding: 20px;
}

.input-icons i {
  position: absolute;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
}

.icon {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 100%;
  padding: 10px;
  text-align: center;
}
.tabs1 {
  color: #6d6e71;
}
.tabs1.active, .tabs1.hover{
  background: #fff;
  color: #e31837;
  border-bottom: 4px solid #e31837;
  font-weight: 600;
  cursor: pointer;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: grey;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out;
    cursor: pointer;
}

.nav-link:focus,
.nav-link:hover {
  color: red;
}
.mob {
  display: none;
}
@media screen and (max-width: 999px) {
  .mob {
    display: block;
  }
}
.desk {
  display: block;
}
@media screen and (max-width: 999px) {
  .desk {
    display: none;
  }
}
.mob-lr-padding0 {
  padding-left: 12px;
  padding-right: 12px;
}
.mob-lr-margin0 {
  margin-left: 12px;
  margin-right: 12px;
}
@media screen and (max-width: 999px) {
  .mob-lr-padding0 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .mob-lr-margin0 {
    margin-left: 0px;
    margin-right: 0px;
  }
}
.accordion-button:not(.collapsed) {
  color: black;
  background-color: white;
}
.accordion-button {
  font-size: 18px;
  font-weight: 600;
}
.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  transform: rotate(-180deg);
}
.accordion-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=file]::-webkit-file-upload-button {
  visibility: hidden;
  margin-left: -48%;
  height: 18px;		
  overflow-x: hidden;	
        
}

.logo-img {
  fill: blue;
}

.logo-img path {
  fill: rgb(241, 15, 56);
}

/* Table vertical scroll css start */
.grid {
  position: relative;
  /* border: 1px solid #000; */
  /* background: #B34C00; */
  width:100%;
  }
  .grid-container {
  overflow-y: auto;
  height: 400px;
  }
  
/* Table vertical scroll css end */
`, "",{"version":3,"sources":["webpack://./src/modules/help/Help.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,QAAQ;EACR,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB;gCAC8B;IAC5B,eAAe;AACnB;;AAEA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yDAA4D;EAC5D,0BAA0B;AAC5B;AACA;EACE,yDAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,UAAU;EACV;EACA;EACA,gBAAgB;EAChB,aAAa;EACb;;AAEF,kCAAkC","sourcesContent":["input[type=\"text\"]:focus{\n  outline: none;\n}\n.tabs {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #eceaea;\n}\n.tabs label {\n  order: 1;\n  color: #6d6e71;\n  display: block;\n  padding: 1rem 2rem;\n  margin-right: 0.2rem;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background ease 0.2s;\n}\n.tabs .tab {\n  order: 99;\n  flex-grow: 1;\n  width: 100%;\n  display: none;\n  padding: 1rem;\n  background: #fff;\n}\n.tabs input[type=\"radio\"] {\n  display: none;\n}\n.tabs input[type=\"radio\"]:checked + label {\n  background: #fff;\n  color: #e31837;\n  border-bottom: 4px solid #e31837;\n  padding-bottom: 10px;\n}\n.tabs input[type=\"radio\"]:checked + label + .tab {\n  display: block;\n}\n\n@media (max-width: 45em) {\n  .tabs .tab,\n  .tabs label {\n    order: initial;\n  }\n  .tabs label {\n    width: 100%;\n    margin-right: 0;\n    margin-top: 0.2rem;\n  }\n}\n\n.tb_content {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n}\n\ntable {\n  border-collapse: collapse;\n  width: 100%;\n}\n\ntr {\n  border-bottom: 1px solid #ddd;\n}\n\n.t_inner {\n  text-align: center;\n  margin-top: 8%;\n  color: #d4cccc;\n}\n\n.rowBg1 {\n  background-color: #fff;\n  padding: 20px;\n}\n\n.input-icons i {\n  position: absolute;\n}\n\n.input-icons {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.icon {\n  padding: 10px;\n  min-width: 40px;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px;\n  text-align: center;\n}\n.tabs1 {\n  color: #6d6e71;\n}\n.tabs1.active, .tabs1.hover{\n  background: #fff;\n  color: #e31837;\n  border-bottom: 4px solid #e31837;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n  color: grey;\n  text-decoration: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out;\n    cursor: pointer;\n}\n\n.nav-link:focus,\n.nav-link:hover {\n  color: red;\n}\n.mob {\n  display: none;\n}\n@media screen and (max-width: 999px) {\n  .mob {\n    display: block;\n  }\n}\n.desk {\n  display: block;\n}\n@media screen and (max-width: 999px) {\n  .desk {\n    display: none;\n  }\n}\n.mob-lr-padding0 {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.mob-lr-margin0 {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n@media screen and (max-width: 999px) {\n  .mob-lr-padding0 {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .mob-lr-margin0 {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: black;\n  background-color: white;\n}\n.accordion-button {\n  font-size: 18px;\n  font-weight: 600;\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: url(../../assets/images/ic-arrow-down.svg);\n  transform: rotate(-180deg);\n}\n.accordion-button::after {\n  background-image: url(../../assets/images/ic-arrow-down.svg);\n}\n\ninput[type=file]::-webkit-file-upload-button {\n  visibility: hidden;\n  margin-left: -48%;\n  height: 18px;\t\t\n  overflow-x: hidden;\t\n        \n}\n\n.logo-img {\n  fill: blue;\n}\n\n.logo-img path {\n  fill: rgb(241, 15, 56);\n}\n\n/* Table vertical scroll css start */\n.grid {\n  position: relative;\n  /* border: 1px solid #000; */\n  /* background: #B34C00; */\n  width:100%;\n  }\n  .grid-container {\n  overflow-y: auto;\n  height: 400px;\n  }\n  \n/* Table vertical scroll css end */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
